module.exports = __webpack_public_path__ + "img/template.13b8c1e5.svg";